let language = {
    "TAXES-HEADING-UK": "EU and UK",
    "TAXES-HEADING-US": "US",
    "TAXES-EN-UK-CONTAINER-DESCRIPTION1": `All orders dispatched to the European Union (EU), and the United Kingdom are subject to
    VAT. To ensure the accurate computation of tax, kindly furnish us with your business's VAT ID number(s), which is also utilized for billing purposes.`,
    "TAXES-EN-UK-CONTAINER-DESCRIPTION2": `Please take note that the submission of VAT ID is distinct from IOSS numbers.If you require assistance in
    submitting your VAT ID, please do not hesitate to contact us.`,
    "TAXES-ACCOUNT-DETAILS-TITLE": "Account Details",
    "TAXES-ACCOUNT-DETAILS-BUTTON-EDIT": "Edit in my account",
    "TAXES-ACCOUNT-DETAILS-BUTTON-EDIT-XS": "Edit",
    "TAXES-ACCOUNT-DETAILS-BUSINESS-SUBTITLE": "Business name",
    "TAXES-ACCOUNT-DETAILS-BUSINESS-COMPLETED": "Not completed",
    "TAXES-ACCOUNT-DETAILS-ACCOUNT-TIPS": "Please complete your account details",
    "TAXES-ACCOUNT-DETAILS-ACCOUNT-BUTTON": "Add detail",
    "TAXES-ACCOUNT-DETAILS-ACCOUNT-DETAIL-SUBTITLE": "VAT ID(s)",
    "TAXES-ACCOUNT-ACCOUNT-VAT-LIST-BUTTON": "Delete",
    "TAXES-STATUS-CONTAINER-VALID": "Valid",
    "TAXES-STATUS-CONTAINER-PENDING": "Pending",
    "TAXES-STATUS-CONTAINER-INVALID": "Invalid",
    "TAXES-VAT-FORM-BOX-TITLE": "Submit VAT",
    "TAXES-VAT-FORM-BOX-COUNTRY": "Country",
    "TAXES-VAT-FORM-BOX-ID": "VAT ID Number",
    "TAXES-VAT-FORM-BOX-ID-PLACEHODER": "Example : DE123456789",
    "TAXES-VAT-FORM-BOX-ID-TIPS": "The number seems to be incorrect. Please review it",
    "TAXES-VAT-FORM-ADD-PREADD-VAT": "Add VAT ID for another country",
    "TAXES-VAT-FORM-CUSTOM-AFFIRM-TEXT": `Hereby I confirm that the provided VAT ID number is assigned to my business
    and should be used going forward to identify my business for the billing and tax reporting purposes.`,
    "TAXES-VAT-FORM-BUTTON-SUBMIT":"Submit VAT ID",

    "TAXES-US-DESCRIPTION1":"{{appName}} applies sales tax to the orders shipped to the states in the USA where {{appName}} is registered for sales tax purposes.",
    "TAXES-US-EXEMPTION-TITLE":"Resale and sales tax exemption certificates",
    "TAXES-US-DESCRIPTION2":`If you are registered for sales tax collection, you can apply for a resale certificate.
    Valid resale certificates can qualify you for a sales tax exemption on orders made through {{appName}}. A
    business license, seller's permit, or other documentation on its own is not equivalent to a resale certificate. However, you can fill out the resale
    certificate form below and become tax-exempt on orders in selected states.`,
    "TAXES-US-CERTIFICATES-TIPS":"The certificates will be reviewed within a week, and, if any changes are needed, we will inform you.",
    "TAXES-US-BUTTON-SUBMIT":"Submit a certificate",
    "TAXES-US-JURSDICTIONS-TABLE-NO":"No.",
    "TAXES-US-JURSDICTIONS-TABLE-JURSDICTIONS":"The jursdictions for the exemption",
    "TAXES-US-JURSDICTIONS-TABLE-EXEMPTION-ID":"Exemption ID",
    "TAXES-US-JURSDICTIONS-TABLE-FORMS":"Form(s)",
    "TAXES-US-JURSDICTIONS-TABLE-STATUS":"Audit status",

    // 问卷
    "TAXES-US-MODAL-FOOTER-CANCEL":"Cancel",
    "TAXES-US-MODAL-FOOTER-BACK":"Back",
    "TAXES-US-MODAL-FOOTER-SKIP":"Skip",
    "TAXES-US-MODAL-FOOTER-NEXT":"Next",
    "TAXES-US-MODAL-FOOTER-SUBMIT":"Submit",
    "TAXES-US-MODAL-FOOTER-DONE":"Done",

    // STEP1
    "TAXES-US-MODAL-STEP1-TITLE":"Exemption Certificate Wizard",
    "TAXES-US-MODAL-STEP1-DESCRIPTION":"Select the jurisdiction(s) for the exemptiony",
    "TAXES-US-MODAL-STEP1-CONTENT-US":"United States",

    // STEP2
    "TAXES-US-MODAL-STEP2-TITLE":"Exemption Certificate Wizard",
    "TAXES-US-MODAL-STEP2-DESCRIPTION":"Please Select any Local Jurisdictions for exemption : ",
    "TAXES-US-MODAL-STEP2-EMPTY-TIPS":"There is no questionnaire for the currently selected exempt area",
    
    // STEP3
    "TAXES-US-MODAL-STEP3-TITLE":"Exemption Certificate Wizard",
    "TAXES-US-MODAL-STEP3-DESCRIPTION":"You are creating a certificate for",
    "TAXES-US-MODAL-STEP3-SELECT-REASON":"Select a reason for the exemption :",
    "TAXES-US-MODAL-STEP3-REQUIRED-TIPS":"Exemption Type Required",
        
    // STEP4
    "TAXES-US-MODAL-STEP4-TITLE":"Exemption Certificate Wizard",
    "TAXES-US-MODAL-STEP4-REQUIRED-TIPS":"Missing required field",

    // STEP5
    "TAXES-US-MODAL-STEP5-TITLE":"Exemption Certificate Wizard",
    "TAXES-US-MODAL-STEP5-DESCRIPTION":"The following forms have been identified.",
    "TAXES-US-MODAL-STEP5-TABLE-HEADER-JURSDICTIONS":"Jursdictions",
    "TAXES-US-MODAL-STEP5-TABLE-HEADER-FORM":"Form",
    "TAXES-US-MODAL-STEP5-TABLE-HEADER-ACTION":"Action",
    "TAXES-US-MODAL-STEP5-TABLE-CONTENT-UPLOAD":"Upload for",
    "TAXES-US-MODAL-STEP5-TABLE-CONTENT-ACTION-UPLOAD":"Upload",
    
    // STEP6
    "TAXES-US-MODAL-STEP6-TITLE":"Upload Forms",
    "TAXES-US-MODAL-STEP6-CONTENT-SELECTED":"Have been selected for upload",
    "TAXES-US-MODAL-STEP6-CONTENT-UPLOAD":"Click to select a file to upload",
    "TAXES-US-MODAL-STEP6-REQUIRED-TIPS":"Please Upload a file before continuing",
    "TAXES-US-MODAL-STEP6-ERROR-TIPS":"Please upload files that are in the formats of jpg, jpeg or png!",
        
    // STEP7
    "TAXES-US-MODAL-STEP7-TITLE":"Buyer Information",
    "TAXES-US-MODAL-STEP7-FORM-COMPANY":"Company name",
    "TAXES-US-MODAL-STEP7-FORM-COMPANY-TIPS":"Company name is required",
    "TAXES-US-MODAL-STEP7-FORM-ADDRESS":"Street Address",
    "TAXES-US-MODAL-STEP7-FORM-ADDRESS-TIPS":"Street Address is required",
    "TAXES-US-MODAL-STEP7-FORM-COUNTRY":"Country / Region",
    "TAXES-US-MODAL-STEP7-FORM-COUNTRY-EMPTY-TIPS":"No results match",
    "TAXES-US-MODAL-STEP7-FORM-COUNTRY-REQUIRED-TIPS":"Country/Region is required",
    "TAXES-US-MODAL-STEP7-FORM-STATE":"State / Province",
    "TAXES-US-MODAL-STEP7-FORM-STATE-EMPTY-TIPS":"No results match",
    "TAXES-US-MODAL-STEP7-FORM-STATE-REQUIRED-TIPS":"State / Province is required",
    "TAXES-US-MODAL-STEP7-FORM-CITY":"City / Town:",
    "TAXES-US-MODAL-STEP7-FORM-CITY-REQUIRED-TIPS":"City is required",
    "TAXES-US-MODAL-STEP7-FORM-POSTAL":"Postal code",
    "TAXES-US-MODAL-STEP7-FORM-POSTAL-REQUIRED-TIPS":"Postal code is required",
    "TAXES-US-MODAL-STEP7-FORM-POSTAL-INVALID-TIPS":"Invalid postal code",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-CODE":"Country code:",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-CODE-REQUIRED-TIPS":"Country code is required",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-CODE-INVALID-TIPS":"Invalid country code",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-NUMBER":"Phone:",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-NUMBER-REQUIRED-TIPS":"Phone is required",
    "TAXES-US-MODAL-STEP7-FORM-PHONE-NUMBER-INVALID-TIPS":"Invalid Phone!",
    "TAXES-US-MODAL-STEP7-FORM-EMAIL":"Your company email",
    "TAXES-US-MODAL-STEP7-FORM-EMAIL-REQUIRED-TIPS":"Email is required",
    "TAXES-US-MODAL-STEP7-FORM-EMAIL-INVALID-TIPS":"Invalid Email!",

    // STEP8
    "TAXES-US-MODAL-STEP8-TITLE":"Additional Documentation (Optional)",
    "TAXES-US-MODAL-STEP8-DESCRIPTION":"Please indicate whether you have additional documentation for each jurisdiction below.",
    "TAXES-US-MODAL-STEP8-SELECTED":"Have been selected for upload",
    "TAXES-US-MODAL-STEP8-CLICK":"Click to select a file to upload.",
    "TAXES-US-MODAL-STEP8-TIPS":`Please attach any additional documentation you may have to support the above exemption. If you do not have any
    supporting documentation, feel free to skip this step.`,
    "TAXES-US-MODAL-STEP8-TIPS-TYPE":"Please upload files that are in the formats of jpg, jpeg or png!",
    "TAXES-US-MODAL-STEP8-TIPS-MAX":"The limit for additional documents is set to a maximum of 3, and it is currently not possible to continue uploading more.",
    
    // STEP9
    "TAXES-US-MODAL-STEP9-TITLE":"Signature Information",
    "TAXES-US-MODAL-STEP9-DESCRIPTION":`By entering my name and my title and the name of my entity/organization and marking
    my signature in the spaces below; by providing additional information to the person required to collect tax
    (seller) that reasonably identities me as the individual named below; and by completing this transaction, I
    understand and agree that I am electronically signing and submitting this sales and use tax resale or exemption
    certificate in connection with a purchase that, but for the presentation of this electronic resale or exemption
    certificate, the seller would otherwise charge and collect sales or
    use tax from me. I also certity to tne truthtulness, completeness, and correctness o all oi the statements
    contained in tnis electronic certiticate and to
    entitlement to the exclusion or exemption from sales or use tax claimed via my submission of this electronic
    certificate to the seller.`,
    "TAXES-US-MODAL-STEP9-FORM-NAME":"Name",
    "TAXES-US-MODAL-STEP9-FORM-NAME-REQUIRED-TIPS":"Name is required",
    "TAXES-US-MODAL-STEP9-FORM-TITLE":"Title",
    "TAXES-US-MODAL-STEP9-FORM-TITLE-REQUIRED-TIPS":"Title is required",
    "TAXES-US-MODAL-STEP9-FORM-DATE":"Effective Date",
    "TAXES-US-MODAL-STEP9-FORM-DATE-REQUIRED-TIPS":"Effective Date is required",
    "TAXES-US-MODAL-STEP9-FORM-SIGNATURE":"Signature",
    "TAXES-US-MODAL-STEP9-FORM-CLICK":"Click to select a file to upload",
    "TAXES-US-MODAL-STEP9-FORM-DATE-UPLOAD":"Upload",
    "TAXES-US-MODAL-STEP9-FORM-SIGNATURE-REQUIRED-TIPS":"Please Upload a file before continuing",
    "TAXES-US-MODAL-STEP9-FORM-SIGNATURE-TYPE-TIPS":"Please upload files that are in the formats of jpg, jpeg or png!",
        
    // STEP10
    "TAXES-US-MODAL-STEP10-TITLE":"Form(s) Complete",
    "TAXES-US-MODAL-STEP10-FORM-HEADER-FORMS":"Forms",
    "TAXES-US-MODAL-STEP10-FORM-HEADER-JURSDICTIONS":"Jursdictions",
    "TAXES-US-MODAL-STEP10-FORM-HEADER-EXEMPTION":"Exemption ID",
    "TAXES-US-MODAL-STEP10-FORM-UPLOAD-FOR":"Upload for",
    "TAXES-US-MODAL-STEP10-FORM-ATTACH-FILE":"Attach file",

};

export { language }